<template>
  <div id="views-page1">
    <!-- 头部 -->
    <HeaderTitle :title="title" :navIndex="4"></HeaderTitle>
    <!-- 内容 -->
    <div class="content">
      <!-- 左 -->
      <div class="left">
        <!-- 供应商 -->
        <div class="left-one">
          <div class="title">供应商</div>
          <div class="left-one-list">
            <vue-seamless-scroll
              :class-option="classOptio"
              :data="listData"
              class="warp"
            >
              <div
                style="cursor: pointer"
                class="left-echarts-box-list-box"
                v-for="(item, index) in listData"
                :key="index"
              >
                <div class="left-one-warp-item">
                  <div>养殖品种</div>
                  <div>{{ item.species }}</div>
                  <div>养殖数量：<span>{{ item.num }}</span>只</div>
                </div>
                <div class="left-one-warp-item1">
                  <div>供应人：<span>{{ item.name }}</span></div>
                  <div>联系方式：<span>{{ item.phone }}</span></div>
                  <div>地址：<span>{{ item.address }}</span></div>
                </div>
                
              </div>
            </vue-seamless-scroll>
          </div>
        </div>
        <!-- 收入来源占比 -->
        <div class="left-two">
          <div class="title">收入来源占比</div>
          <income style="margin: 20px 0;width: 100%;height: 270px;"></income>
        </div>
      </div>
      <!-- 中间 -->
      <div class="center">
        <!-- 全国销量产图 -->
        <div class="center-one">
          <div class="title">全国销量产图</div>
          <mapprice style="width: 100%;height: 560px;"></mapprice>
        </div>
        <!-- 年度鸡蛋价格趋势 -->
        <div class="center-two">
          <div class="title" style="padding-left: 60px">年度鸡蛋价格趋势</div>
          <priceage style="width: 100%;margin-top: 20px;height: 270px;"></priceage>
        </div>
      </div>
      <!-- 右 -->
      <div class="right">
        <!-- 投入品占比 -->
        <div class="right-one">
          <div class="title">投入品占比</div>
          <inpouts style="width: 100%;height: 250px;margin-top: 20px;"></inpouts>
        </div>
        <!-- 粪便资源化收益 -->
        <div class="right-two">
          <div class="title">粪便资源化收益</div>
          <fecesasd style="width: 100%;height: 250px;margin-top: 20px;"></fecesasd>
        </div>
        <!-- 每月收支数据 -->
        <div class="right-three">
          <div class="title">每月收支数据</div>
          <revenue style="width: 100%;height: 250px;margin-top: 20px;"></revenue>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// 收入来源占比
import income from "../../components/price/income";
// 引入地图
import mapprice from "../../components/price/map";
// 引入投入品占比
import inpouts from "../../components/price/input";
// 粪便资源化收益
import fecesasd from "../../components/price/feces";
// 每月收支数据
import revenue from "../../components/price/revenue";
// 年度鸡蛋价格趋势
import priceage from "../../components/price/priceage";

// 头部
import HeaderTitle from "../../components/HeaderTitle.vue";
export default {
  components: {
    HeaderTitle,
    income,
    mapprice,
    inpouts,
    fecesasd,
    revenue,
    priceage
  },
  data() {
    return {
      title: "禽蛋销售全网数据分析一张图",
      listData: [
        {
          address: "柴堡镇韩马堡",
          name: "韩张禄",
          phone: "15230010699",
          species: "京粉",
          num: "5000",
        },
        {
          address: "柴堡镇韩马堡",
          name: "马振广",
          phone: "13473025171",
          species: "京粉",
          num: "3000",
        },
        {
          address: "柴堡镇韩马堡",
          name: "韩康",
          phone: "15132032120",
          species: "京粉-海兰灰",
          num: "5000",
        },
        {
          address: "柴堡镇韩马堡",
          name: "赵庆华",
          phone: "15903308871",
          species: "新海兰-京粉",
          num: "17000",
        },
        {
          address: "柴堡镇韩马堡",
          name: "赵庆立",
          phone: "15231861279",
          species: "京粉",
          num: "14000",
        },
        {
          address: "柴堡镇韩马堡",
          name: "郭保太",
          phone: "13463045375",
          species: "京粉",
          num: "9000",
        },
        {
          address: "柴堡镇韩马堡",
          name: "赵金军",
          phone: "13830034733",
          species: "新海兰-京粉",
          num: "25000",
        },
        {
          address: "柴堡镇韩马堡",
          name: "郭保林",
          phone: "13031994876",
          species: "京粉",
          num: "13000",
        },
        {
          address: "柴堡镇韩马堡",
          name: "赵庆磊",
          phone: "13931085268",
          species: "京粉",
          num: "18000",
        },
        {
          address: "柴堡镇韩马堡",
          name: "郭保新",
          phone: "15632018684",
          species: "京粉-海兰灰",
          num: "13000",
        },
        {
          address: "柴堡镇韩马堡",
          name: "郭保奇",
          phone: "15081047707",
          species: "京粉",
          num: "11000",
        },
        {
          address: "柴堡镇韩马堡",
          name: "赵庆斌",
          phone: "15032898477",
          species: "京粉",
          num: "12000",
        },
        {
          address: "柴堡镇韩马堡",
          name: "郭延祥",
          phone: "15946738210",
          species: "京粉",
          num: "9000",
        },
        {
          address: "柴堡镇后刘堡",
          name: "谷影",
          phone: "15530031999",
          species: "京粉",
          num: "40000",
        },
        {
          address: "柴堡镇前刘堡",
          name: "闫梦运",
          phone: "152830063309",
          species: "京粉-海兰灰",
          num: "5000",
        },
        {
          address: "柴堡镇前刘堡",
          name: "尹常杰",
          phone: "15630096671",
          species: "新海兰-京粉",
          num: "8000",
        },
        {
          address: "柴堡镇前刘堡",
          name: "闫兆建",
          phone: "13730040613",
          species: "京粉",
          num: "8000",
        },

        {
          address: "柴堡镇前刘堡",
          name: "闫兆磊",
          phone: "13831084916",
          species: "京粉",
          num: "4000",
        },
        {
          address: "柴堡镇前刘堡",
          name: "闫梦书",
          phone: "15028078568",
          species: "京粉",
          num: "4000",
        },
      ],
      classOptio: {
        step: 1,
      },
    };
  },
  created() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
#views-page1 {
  box-sizing: border-box;
  background: url(~@/assets/background-img.png) no-repeat center center;
  background-size: 100% 100%;
  width: 1920px;
  height: 1080px;
  overflow: hidden;
}
// 内容
.content {
  color: #fff;
  width: 100%;
  height: 90%;
  box-sizing: border-box;
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  // 左
  .left {
    width: 28%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    // 供应商
    .left-one {
      width: 100%;
      height: 63%;
      background-image: url("../../assets/price/chang.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
      .left-one-list {
        width: 96%;
        margin: 15px auto 0;
        height: 540px;
        .warp {
          width: 100%;
          height: 540px;
          margin: auto 0;
          overflow: hidden;
          .left-echarts-box-list-box {
            display: flex;
            align-items: center;
            justify-content: space-between;
            border-bottom: 1px solid #1c4065;
            height: 150px;
            width: 100%;
            .left-one-warp-item {
              width: 50%;
              height: 130px;
              background-image: url("../../assets/price/biaotikuang.png");
              background-size: 100% 100%;
              background-repeat: no-repeat;
              div{
                &:nth-child(1){
                  padding-left: 13px;
                  color: #ccc;
                }
                &:nth-child(2){
                  margin: 0 0 10px 70px;
                  font-size: 20px;
                  font-weight: 600;
                  letter-spacing: 3px;
                  background: linear-gradient(to bottom, #ffffff, #a3dcff);
                  -webkit-background-clip: text !important;
                  background-clip: text;
                  color: transparent;
                }
                &:nth-child(3){
                  color: #00a0e9;
                  font-size: 20px;
                  margin-top: 20px;
                  letter-spacing: 2px;
                  span{
                    padding: 0 5px;
                    font-size: 26px;
                    font-weight: 600;
                    color: #fff;
                  }
                }
              }
            }
            .left-one-warp-item1 {
              width: 46%;
              line-height: 30px;
              font-size: 16px;
              div{
                span{
                  font-size: 20px;
                  letter-spacing: 2px;
                  font-weight: 600;
                  background: linear-gradient(to bottom, #ffffff, #a3dcff);
                  -webkit-background-clip: text !important;
                  background-clip: text;
                  color: transparent;
                }
              }
            }
          }
        }
      }
    }
    // 收入来源占比
    .left-two {
      width: 100%;
      height: 35%;
      background-image: url("../../assets/cockpit/back-1.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
    }
  }
  // 中间
  .center {
    width: 42%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    // 全国销量产图
    .center-one {
      width: 100%;
      height: 63%;
      background-image: url("../../assets/price/zhongjiankuang.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
    }
    // 年度鸡蛋价格趋势
    .center-two {
      width: 100%;
      height: 35%;
      background-image: url("../../assets/cockpit/back-1.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
    }
  }
  // 右
  .right {
    width: 28%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    // 投入品占比
    .right-one {
      width: 100%;
      height: 33%;
      background-image: url("../../assets/cockpit/back-1.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
    }
    // 粪便资源化收益
    .right-two {
      width: 100%;
      height: 33%;
      background-image: url("../../assets/cockpit/back-1.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
    }
    // 每月收支数据
    .right-three {
      width: 100%;
      height: 33%;
      background-image: url("../../assets/cockpit/back-1.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
    }
  }
}
// 模块名称
.title {
  font-size: 20px;
  letter-spacing: 2px;
  font-weight: bold;
  background: linear-gradient(to bottom, #ffffff, #a3dcff);
  -webkit-background-clip: text !important;
  background-clip: text;
  color: transparent;
  padding: 13px 0 0 40px;
}
</style>
